/* tslint:disable */
/* eslint-disable */
/**
 * Integrations Service
 * Provides an API to integrate with various 3rd party integrations
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ContactDetailsRequest,
  ContactDetailsResponse,
  DescribeEntityRequest,
  DescribeMappableEntityRequest,
  DescribeMappableEntityResponse,
  DescribeObjectResponse,
  DescribeOpportunityFieldsResponse,
  FetchPropertyValuesRequest,
  FetchPropertyValuesResponse,
  FindProviderResponse,
  HealthControllerReadiness200Response,
  HealthControllerReadiness503Response,
  InstallUrlRequest,
  InstallUrlResponse,
  LeadFieldOptionsRequest,
  LeadFieldOptionsResponse,
  ListFieldMappingsResponse,
  OpportunityConfigBuilderRequest,
  OpportunityConfigBuilderResponse,
  OpportunityDetailsRequest,
  OpportunityDetailsResponse,
  OpportunityFormResponse,
  OpportunityListEntitiesResponse,
  ParagonInstallRequest,
  ParagonUninstallRequest,
  ProviderListResponse,
  SaveFieldMappingRequest,
  SaveFieldMappingResponse,
  SearchAccountsRequest,
  SearchAccountsResponse,
  SearchOwnersResponse,
  SendContactRequest,
  SendContactResponse,
  SendLeadRequest,
  SendOpportunityRequest,
  SendOpportunityResponse,
  UpdateParagonExtrasRequest,
} from '../models';
import {
    ContactDetailsRequestFromJSON,
    ContactDetailsRequestToJSON,
    ContactDetailsResponseFromJSON,
    ContactDetailsResponseToJSON,
    DescribeEntityRequestFromJSON,
    DescribeEntityRequestToJSON,
    DescribeMappableEntityRequestFromJSON,
    DescribeMappableEntityRequestToJSON,
    DescribeMappableEntityResponseFromJSON,
    DescribeMappableEntityResponseToJSON,
    DescribeObjectResponseFromJSON,
    DescribeObjectResponseToJSON,
    DescribeOpportunityFieldsResponseFromJSON,
    DescribeOpportunityFieldsResponseToJSON,
    FetchPropertyValuesRequestFromJSON,
    FetchPropertyValuesRequestToJSON,
    FetchPropertyValuesResponseFromJSON,
    FetchPropertyValuesResponseToJSON,
    FindProviderResponseFromJSON,
    FindProviderResponseToJSON,
    HealthControllerReadiness200ResponseFromJSON,
    HealthControllerReadiness200ResponseToJSON,
    HealthControllerReadiness503ResponseFromJSON,
    HealthControllerReadiness503ResponseToJSON,
    InstallUrlRequestFromJSON,
    InstallUrlRequestToJSON,
    InstallUrlResponseFromJSON,
    InstallUrlResponseToJSON,
    LeadFieldOptionsRequestFromJSON,
    LeadFieldOptionsRequestToJSON,
    LeadFieldOptionsResponseFromJSON,
    LeadFieldOptionsResponseToJSON,
    ListFieldMappingsResponseFromJSON,
    ListFieldMappingsResponseToJSON,
    OpportunityConfigBuilderRequestFromJSON,
    OpportunityConfigBuilderRequestToJSON,
    OpportunityConfigBuilderResponseFromJSON,
    OpportunityConfigBuilderResponseToJSON,
    OpportunityDetailsRequestFromJSON,
    OpportunityDetailsRequestToJSON,
    OpportunityDetailsResponseFromJSON,
    OpportunityDetailsResponseToJSON,
    OpportunityFormResponseFromJSON,
    OpportunityFormResponseToJSON,
    OpportunityListEntitiesResponseFromJSON,
    OpportunityListEntitiesResponseToJSON,
    ParagonInstallRequestFromJSON,
    ParagonInstallRequestToJSON,
    ParagonUninstallRequestFromJSON,
    ParagonUninstallRequestToJSON,
    ProviderListResponseFromJSON,
    ProviderListResponseToJSON,
    SaveFieldMappingRequestFromJSON,
    SaveFieldMappingRequestToJSON,
    SaveFieldMappingResponseFromJSON,
    SaveFieldMappingResponseToJSON,
    SearchAccountsRequestFromJSON,
    SearchAccountsRequestToJSON,
    SearchAccountsResponseFromJSON,
    SearchAccountsResponseToJSON,
    SearchOwnersResponseFromJSON,
    SearchOwnersResponseToJSON,
    SendContactRequestFromJSON,
    SendContactRequestToJSON,
    SendContactResponseFromJSON,
    SendContactResponseToJSON,
    SendLeadRequestFromJSON,
    SendLeadRequestToJSON,
    SendOpportunityRequestFromJSON,
    SendOpportunityRequestToJSON,
    SendOpportunityResponseFromJSON,
    SendOpportunityResponseToJSON,
    UpdateParagonExtrasRequestFromJSON,
    UpdateParagonExtrasRequestToJSON,
} from '../models';

export interface DescribeContactDetailsRequest {
    contactDetailsRequest: ContactDetailsRequest;
}

export interface DescribeEntityOperationRequest {
    describeEntityRequest: DescribeEntityRequest;
}

export interface DescribeMappableEntityOperationRequest {
    describeMappableEntityRequest: DescribeMappableEntityRequest;
}

export interface FetchPropertyValuesOperationRequest {
    fetchPropertyValuesRequest: FetchPropertyValuesRequest;
}

export interface InstallCompleteCallbackRequest {
    state: string;
    code: string;
}

export interface IntegrationInstallUrlRequest {
    providerId: string;
    installUrlRequest: InstallUrlRequest;
}

export interface LeadFieldOptionsOperationRequest {
    leadFieldOptionsRequest: LeadFieldOptionsRequest;
}

export interface OpportunityDetailsOperationRequest {
    opportunityDetailsRequest: OpportunityDetailsRequest;
}

export interface RecordParagonInstallRequest {
    paragonInstallRequest: ParagonInstallRequest;
}

export interface RemoveParagonInstallRequest {
    paragonUninstallRequest: ParagonUninstallRequest;
}

export interface SaveFieldMappingOperationRequest {
    saveFieldMappingRequest: SaveFieldMappingRequest;
}

export interface SearchAccountsOperationRequest {
    searchAccountsRequest: SearchAccountsRequest;
}

export interface SendContactOperationRequest {
    sendContactRequest: SendContactRequest;
}

export interface SendLeadOperationRequest {
    sendLeadRequest: SendLeadRequest;
}

export interface SendOpportunityOperationRequest {
    sendOpportunityRequest: SendOpportunityRequest;
}

export interface UninstallRequest {
    providerId: string;
}

export interface UpdateOpportunityConfigRequest {
    opportunityConfigBuilderRequest: OpportunityConfigBuilderRequest;
}

export interface UpdateParagonInstallExtrasRequest {
    updateParagonExtrasRequest: UpdateParagonExtrasRequest;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     * 
     */
    async describeContactDetailsRaw(requestParameters: DescribeContactDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContactDetailsResponse>> {
        if (requestParameters.contactDetailsRequest === null || requestParameters.contactDetailsRequest === undefined) {
            throw new runtime.RequiredError('contactDetailsRequest','Required parameter requestParameters.contactDetailsRequest was null or undefined when calling describeContactDetails.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/services/integration/crm/contacts/details`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ContactDetailsRequestToJSON(requestParameters.contactDetailsRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContactDetailsResponseFromJSON(jsonValue));
    }

    /**
     * 
     */
    async describeContactDetails(requestParameters: DescribeContactDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContactDetailsResponse> {
        const response = await this.describeContactDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async describeEntityRaw(requestParameters: DescribeEntityOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DescribeObjectResponse>> {
        if (requestParameters.describeEntityRequest === null || requestParameters.describeEntityRequest === undefined) {
            throw new runtime.RequiredError('describeEntityRequest','Required parameter requestParameters.describeEntityRequest was null or undefined when calling describeEntity.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/services/integration/crm/provider/describeEntity`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DescribeEntityRequestToJSON(requestParameters.describeEntityRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DescribeObjectResponseFromJSON(jsonValue));
    }

    /**
     * 
     */
    async describeEntity(requestParameters: DescribeEntityOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DescribeObjectResponse> {
        const response = await this.describeEntityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async describeMappableEntityRaw(requestParameters: DescribeMappableEntityOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DescribeMappableEntityResponse>> {
        if (requestParameters.describeMappableEntityRequest === null || requestParameters.describeMappableEntityRequest === undefined) {
            throw new runtime.RequiredError('describeMappableEntityRequest','Required parameter requestParameters.describeMappableEntityRequest was null or undefined when calling describeMappableEntity.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/services/integration/crm/field-mapping/describe`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DescribeMappableEntityRequestToJSON(requestParameters.describeMappableEntityRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DescribeMappableEntityResponseFromJSON(jsonValue));
    }

    /**
     * 
     */
    async describeMappableEntity(requestParameters: DescribeMappableEntityOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DescribeMappableEntityResponse> {
        const response = await this.describeMappableEntityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async describeOpportunityFieldsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DescribeOpportunityFieldsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/services/integration/crm/opportunities/describeOpportunityFields`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DescribeOpportunityFieldsResponseFromJSON(jsonValue));
    }

    /**
     * 
     */
    async describeOpportunityFields(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DescribeOpportunityFieldsResponse> {
        const response = await this.describeOpportunityFieldsRaw(initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async fetchPropertyValuesRaw(requestParameters: FetchPropertyValuesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FetchPropertyValuesResponse>> {
        if (requestParameters.fetchPropertyValuesRequest === null || requestParameters.fetchPropertyValuesRequest === undefined) {
            throw new runtime.RequiredError('fetchPropertyValuesRequest','Required parameter requestParameters.fetchPropertyValuesRequest was null or undefined when calling fetchPropertyValues.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/services/integration/crm/provider/fetchPropertyValues`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FetchPropertyValuesRequestToJSON(requestParameters.fetchPropertyValuesRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FetchPropertyValuesResponseFromJSON(jsonValue));
    }

    /**
     * 
     */
    async fetchPropertyValues(requestParameters: FetchPropertyValuesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FetchPropertyValuesResponse> {
        const response = await this.fetchPropertyValuesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async fetchProviderRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindProviderResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/services/integration/crm/provider/fetchProvider`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindProviderResponseFromJSON(jsonValue));
    }

    /**
     * 
     */
    async fetchProvider(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindProviderResponse> {
        const response = await this.fetchProviderRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async healthControllerReadinessRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HealthControllerReadiness200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/health`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HealthControllerReadiness200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async healthControllerReadiness(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HealthControllerReadiness200Response> {
        const response = await this.healthControllerReadinessRaw(initOverrides);
        return await response.value();
    }

    /**
     * Callback called by the provider once the user has signed in. Saves the auth token and an install in our DB
     * 
     */
    async installCompleteCallbackRaw(requestParameters: InstallCompleteCallbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.state === null || requestParameters.state === undefined) {
            throw new runtime.RequiredError('state','Required parameter requestParameters.state was null or undefined when calling installCompleteCallback.');
        }

        if (requestParameters.code === null || requestParameters.code === undefined) {
            throw new runtime.RequiredError('code','Required parameter requestParameters.code was null or undefined when calling installCompleteCallback.');
        }

        const queryParameters: any = {};

        if (requestParameters.state !== undefined) {
            queryParameters['state'] = requestParameters.state;
        }

        if (requestParameters.code !== undefined) {
            queryParameters['code'] = requestParameters.code;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/services/integration/oauth/callback`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Callback called by the provider once the user has signed in. Saves the auth token and an install in our DB
     * 
     */
    async installCompleteCallback(requestParameters: InstallCompleteCallbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.installCompleteCallbackRaw(requestParameters, initOverrides);
    }

    /**
     * For each integration creates a url that initiates an oauth sign in with their provider
     * 
     */
    async integrationInstallUrlRaw(requestParameters: IntegrationInstallUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InstallUrlResponse>> {
        if (requestParameters.providerId === null || requestParameters.providerId === undefined) {
            throw new runtime.RequiredError('providerId','Required parameter requestParameters.providerId was null or undefined when calling integrationInstallUrl.');
        }

        if (requestParameters.installUrlRequest === null || requestParameters.installUrlRequest === undefined) {
            throw new runtime.RequiredError('installUrlRequest','Required parameter requestParameters.installUrlRequest was null or undefined when calling integrationInstallUrl.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/services/integration/crm/provider/{providerId}/install`.replace(`{${"providerId"}}`, encodeURIComponent(String(requestParameters.providerId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InstallUrlRequestToJSON(requestParameters.installUrlRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InstallUrlResponseFromJSON(jsonValue));
    }

    /**
     * For each integration creates a url that initiates an oauth sign in with their provider
     * 
     */
    async integrationInstallUrl(requestParameters: IntegrationInstallUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InstallUrlResponse> {
        const response = await this.integrationInstallUrlRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * The values a mapped field accepts, so the send form can offer a dropdown. Empty for a field that takes any value.
     * 
     */
    async leadFieldOptionsRaw(requestParameters: LeadFieldOptionsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LeadFieldOptionsResponse>> {
        if (requestParameters.leadFieldOptionsRequest === null || requestParameters.leadFieldOptionsRequest === undefined) {
            throw new runtime.RequiredError('leadFieldOptionsRequest','Required parameter requestParameters.leadFieldOptionsRequest was null or undefined when calling leadFieldOptions.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/services/integration/crm/leads/field-options`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LeadFieldOptionsRequestToJSON(requestParameters.leadFieldOptionsRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LeadFieldOptionsResponseFromJSON(jsonValue));
    }

    /**
     * The values a mapped field accepts, so the send form can offer a dropdown. Empty for a field that takes any value.
     * 
     */
    async leadFieldOptions(requestParameters: LeadFieldOptionsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LeadFieldOptionsResponse> {
        const response = await this.leadFieldOptionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async listFieldMappingsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListFieldMappingsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/services/integration/crm/field-mapping/list`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListFieldMappingsResponseFromJSON(jsonValue));
    }

    /**
     * 
     */
    async listFieldMappings(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListFieldMappingsResponse> {
        const response = await this.listFieldMappingsRaw(initOverrides);
        return await response.value();
    }

    /**
     * List provider options for a given company that will be displayed in the integration marketplace
     * 
     */
    async listProvidersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProviderListResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/services/integration/crm/provider/list`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderListResponseFromJSON(jsonValue));
    }

    /**
     * List provider options for a given company that will be displayed in the integration marketplace
     * 
     */
    async listProviders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProviderListResponse> {
        const response = await this.listProvidersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async livenessControllerLivezRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/livez`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async livenessControllerLivez(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.livenessControllerLivezRaw(initOverrides);
    }

    /**
     * 
     */
    async opportunityDetailsRaw(requestParameters: OpportunityDetailsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OpportunityDetailsResponse>> {
        if (requestParameters.opportunityDetailsRequest === null || requestParameters.opportunityDetailsRequest === undefined) {
            throw new runtime.RequiredError('opportunityDetailsRequest','Required parameter requestParameters.opportunityDetailsRequest was null or undefined when calling opportunityDetails.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/services/integration/crm/opportunities/details`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OpportunityDetailsRequestToJSON(requestParameters.opportunityDetailsRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OpportunityDetailsResponseFromJSON(jsonValue));
    }

    /**
     * 
     */
    async opportunityDetails(requestParameters: OpportunityDetailsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OpportunityDetailsResponse> {
        const response = await this.opportunityDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async opportunityFormSchemaRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OpportunityFormResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/services/integration/crm/opportunities/opportunity-form-schema`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OpportunityFormResponseFromJSON(jsonValue));
    }

    /**
     * 
     */
    async opportunityFormSchema(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OpportunityFormResponse> {
        const response = await this.opportunityFormSchemaRaw(initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async opportunityListEntitiesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OpportunityListEntitiesResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/services/integration/crm/opportunities/listEntities`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OpportunityListEntitiesResponseFromJSON(jsonValue));
    }

    /**
     * 
     */
    async opportunityListEntities(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OpportunityListEntitiesResponse> {
        const response = await this.opportunityListEntitiesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Records a CRM connection the user made through Paragon. Paragon holds the credentials, so there is nothing to exchange — this just tells the service the company has a CRM and which object to push to.
     * 
     */
    async recordParagonInstallRaw(requestParameters: RecordParagonInstallRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.paragonInstallRequest === null || requestParameters.paragonInstallRequest === undefined) {
            throw new runtime.RequiredError('paragonInstallRequest','Required parameter requestParameters.paragonInstallRequest was null or undefined when calling recordParagonInstall.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/services/integration/crm/provider/paragon-install`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ParagonInstallRequestToJSON(requestParameters.paragonInstallRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Records a CRM connection the user made through Paragon. Paragon holds the credentials, so there is nothing to exchange — this just tells the service the company has a CRM and which object to push to.
     * 
     */
    async recordParagonInstall(requestParameters: RecordParagonInstallRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.recordParagonInstallRaw(requestParameters, initOverrides);
    }

    /**
     * Retires a CRM install after the user disconnected it in Paragon, which does not notify this service.
     * 
     */
    async removeParagonInstallRaw(requestParameters: RemoveParagonInstallRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.paragonUninstallRequest === null || requestParameters.paragonUninstallRequest === undefined) {
            throw new runtime.RequiredError('paragonUninstallRequest','Required parameter requestParameters.paragonUninstallRequest was null or undefined when calling removeParagonInstall.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/services/integration/crm/provider/paragon-uninstall`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ParagonUninstallRequestToJSON(requestParameters.paragonUninstallRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Retires a CRM install after the user disconnected it in Paragon, which does not notify this service.
     * 
     */
    async removeParagonInstall(requestParameters: RemoveParagonInstallRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeParagonInstallRaw(requestParameters, initOverrides);
    }

    /**
     * 
     */
    async saveFieldMappingRaw(requestParameters: SaveFieldMappingOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SaveFieldMappingResponse>> {
        if (requestParameters.saveFieldMappingRequest === null || requestParameters.saveFieldMappingRequest === undefined) {
            throw new runtime.RequiredError('saveFieldMappingRequest','Required parameter requestParameters.saveFieldMappingRequest was null or undefined when calling saveFieldMapping.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/services/integration/crm/field-mapping/save`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SaveFieldMappingRequestToJSON(requestParameters.saveFieldMappingRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SaveFieldMappingResponseFromJSON(jsonValue));
    }

    /**
     * 
     */
    async saveFieldMapping(requestParameters: SaveFieldMappingOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SaveFieldMappingResponse> {
        const response = await this.saveFieldMappingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async searchAccountsRaw(requestParameters: SearchAccountsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchAccountsResponse>> {
        if (requestParameters.searchAccountsRequest === null || requestParameters.searchAccountsRequest === undefined) {
            throw new runtime.RequiredError('searchAccountsRequest','Required parameter requestParameters.searchAccountsRequest was null or undefined when calling searchAccounts.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/services/integration/crm/accounts/search-accounts`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchAccountsRequestToJSON(requestParameters.searchAccountsRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchAccountsResponseFromJSON(jsonValue));
    }

    /**
     * 
     */
    async searchAccounts(requestParameters: SearchAccountsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchAccountsResponse> {
        const response = await this.searchAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async searchOwnersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchOwnersResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/services/integration/crm/owners/search-owners`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchOwnersResponseFromJSON(jsonValue));
    }

    /**
     * 
     */
    async searchOwners(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchOwnersResponse> {
        const response = await this.searchOwnersRaw(initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async sendContactRaw(requestParameters: SendContactOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SendContactResponse>> {
        if (requestParameters.sendContactRequest === null || requestParameters.sendContactRequest === undefined) {
            throw new runtime.RequiredError('sendContactRequest','Required parameter requestParameters.sendContactRequest was null or undefined when calling sendContact.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/services/integration/crm/contacts/send`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SendContactRequestToJSON(requestParameters.sendContactRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SendContactResponseFromJSON(jsonValue));
    }

    /**
     * 
     */
    async sendContact(requestParameters: SendContactOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SendContactResponse> {
        const response = await this.sendContactRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Pushes a lead to a CRM connected through Paragon. The entity comes with the request because the client reads it from the field mapping Paragon holds.
     * 
     */
    async sendLeadRaw(requestParameters: SendLeadOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SendOpportunityResponse>> {
        if (requestParameters.sendLeadRequest === null || requestParameters.sendLeadRequest === undefined) {
            throw new runtime.RequiredError('sendLeadRequest','Required parameter requestParameters.sendLeadRequest was null or undefined when calling sendLead.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/services/integration/crm/leads/send`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SendLeadRequestToJSON(requestParameters.sendLeadRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SendOpportunityResponseFromJSON(jsonValue));
    }

    /**
     * Pushes a lead to a CRM connected through Paragon. The entity comes with the request because the client reads it from the field mapping Paragon holds.
     * 
     */
    async sendLead(requestParameters: SendLeadOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SendOpportunityResponse> {
        const response = await this.sendLeadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async sendOpportunityRaw(requestParameters: SendOpportunityOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SendOpportunityResponse>> {
        if (requestParameters.sendOpportunityRequest === null || requestParameters.sendOpportunityRequest === undefined) {
            throw new runtime.RequiredError('sendOpportunityRequest','Required parameter requestParameters.sendOpportunityRequest was null or undefined when calling sendOpportunity.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/services/integration/crm/opportunities/send`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SendOpportunityRequestToJSON(requestParameters.sendOpportunityRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SendOpportunityResponseFromJSON(jsonValue));
    }

    /**
     * 
     */
    async sendOpportunity(requestParameters: SendOpportunityOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SendOpportunityResponse> {
        const response = await this.sendOpportunityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Remove the installation data for a given provider id. We also remove the refresh and access tokens.
     * 
     */
    async uninstallRaw(requestParameters: UninstallRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.providerId === null || requestParameters.providerId === undefined) {
            throw new runtime.RequiredError('providerId','Required parameter requestParameters.providerId was null or undefined when calling uninstall.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/services/integration/crm/provider/{providerId}/uninstall`.replace(`{${"providerId"}}`, encodeURIComponent(String(requestParameters.providerId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Remove the installation data for a given provider id. We also remove the refresh and access tokens.
     * 
     */
    async uninstall(requestParameters: UninstallRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.uninstallRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async updateOpportunityConfigRaw(requestParameters: UpdateOpportunityConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OpportunityConfigBuilderResponse>> {
        if (requestParameters.opportunityConfigBuilderRequest === null || requestParameters.opportunityConfigBuilderRequest === undefined) {
            throw new runtime.RequiredError('opportunityConfigBuilderRequest','Required parameter requestParameters.opportunityConfigBuilderRequest was null or undefined when calling updateOpportunityConfig.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/services/integration/crm/opportunities/updateOpportunityConfig`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OpportunityConfigBuilderRequestToJSON(requestParameters.opportunityConfigBuilderRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OpportunityConfigBuilderResponseFromJSON(jsonValue));
    }

    /**
     * 
     */
    async updateOpportunityConfig(requestParameters: UpdateOpportunityConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OpportunityConfigBuilderResponse> {
        const response = await this.updateOpportunityConfigRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Stores the extra CRM fields a company collects at send time on its Paragon-backed install, including which of them are required.
     * 
     */
    async updateParagonInstallExtrasRaw(requestParameters: UpdateParagonInstallExtrasRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.updateParagonExtrasRequest === null || requestParameters.updateParagonExtrasRequest === undefined) {
            throw new runtime.RequiredError('updateParagonExtrasRequest','Required parameter requestParameters.updateParagonExtrasRequest was null or undefined when calling updateParagonInstallExtras.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/services/integration/crm/provider/paragon-install/extras`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateParagonExtrasRequestToJSON(requestParameters.updateParagonExtrasRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Stores the extra CRM fields a company collects at send time on its Paragon-backed install, including which of them are required.
     * 
     */
    async updateParagonInstallExtras(requestParameters: UpdateParagonInstallExtrasRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateParagonInstallExtrasRaw(requestParameters, initOverrides);
    }

}
